const ValidateCreateDevice = (formState) => {
  const form = {};
  const requiredFields = ['selectedRegion', 'deviceId', 'command'];
  const specialCharRegex = /[^a-zA-Z0-9]/;

  requiredFields.forEach((field) => {
    const value = formState[field]?.toString().trim();

    if (!value) {
      form._error = "Required field missing";
      form.invalid = true;
      form[`${field}Error`] = true;
    } else if (field === 'deviceId' && specialCharRegex.test(value)) {
      form._error = "Special character and white space not allowed";
      form.invalid = true;
      form[`${field}SpecialChar`] = true;
    }
  });

  return form;
};

export default ValidateCreateDevice;
